import axios from 'axios';

async function getVacancy(OIDN) {
  try {
    const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/api/vacancy/company/${OIDN}`);
    return data;
  } catch (error) {
    if (error.status === 404) {
      console.error('vacancy not found, redirecting...');
      window.location.href = '/';
    }
    throw error;
  }
}

async function getVacancies(locationDetails, mode, time = undefined) {
  const params = new URLSearchParams({
    type: locationDetails.type,
    lat: locationDetails.lat,
    lng: locationDetails.lng,
    mode,
  });

  if (locationDetails.radius) {
    params.append('radius', locationDetails.radius);
  }

  if (locationDetails.cutoff) {
    params.append('cutoff', locationDetails.cutoff);
  }

  if (time) {
    params.append('time', time);
  }

  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/api/vacancy?${params.toString()}`);

  if (import.meta.env.VITE_NAZKA_ENV === 'development') {
    if (data.isochroneRequestTime && data.isochroneService) {
      // eslint-disable-next-line no-console
      console.log(`Isochrone service used: ${data.isochroneService}, it took ${data.isochroneRequestTime} to fetch isochrone data`);
    }

    if (data.vacanciesRequestTime) {
      // eslint-disable-next-line no-console
      console.log(`It took ${data.vacanciesRequestTime} to fetch vacancies data`);
    }
  }

  return data;
}

async function getVacancyCount() {
  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/api/vacancy/count`);

  return data;
}

async function getVacancyFilterOptions() {
  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/api/vacancy/filter`);

  return data;
}

export {
  getVacancy,
  getVacancies,
  getVacancyCount,
  getVacancyFilterOptions,
};